import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as ArrowDownIcon } from "../../../../assets/icons/arrow-down.svg";

const ProviderSelectField = ({
  label,
  value,
  options = [],
  placeholder = "Select option",
  onChange,
  disabled = false,
  className = "",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);

  const selectedOption = options.find((option) => option.value === value);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!selectRef.current?.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelect = (option) => {
    if (disabled) return;

    onChange?.(option.value);
    setIsOpen(false);
  };

  return (
    <div ref={selectRef} className={`provider-select-field ${className}`}>
      {label && (
        <label className="provider-select-field__label FP_Help_Text">
          {label}
        </label>
      )}

      <button
        type="button"
        className={`provider-select-field__button ${isOpen ? "is-open" : ""}`}
        onClick={() => !disabled && setIsOpen((prev) => !prev)}
        disabled={disabled}
      >
        <span className="FP_Content black">
          {selectedOption?.label || placeholder}
        </span>

        <ArrowDownIcon className="provider-select-field__icon" />
      </button>

      {isOpen && (
        <div className="provider-select-field__menu">
          {options.map((option) => (
            <button
              key={option.value}
              type="button"
              className={`provider-select-field__option ${
                option.value === value ? "is-active" : ""
              }`}
              onClick={() => handleSelect(option)}
            >
              <span className="FP_Content black">{option.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProviderSelectField;
